import { DocumentRoute } from '/@/modules/document/routes/document.routes';
import { DocumentRouteConfig } from '/@/modules/document/routes/DocumentRouteConfig';

export const router = [
  DocumentRouteConfig.factory({
    path: `/${DocumentRoute.DOCUMENT.path}`,
    name: DocumentRoute.DOCUMENT.name,
    component: () => import('/@/modules/document/pages/DocumentsPage.vue'),
    meta: { authOnly: true }
  }).build()
];
